module.exports = __webpack_public_path__ + "static/mstile-70x70-2a9f1dd34e0ef87a3ad811794682f6d4.png";